module.exports = __webpack_public_path__ + "img/tips3list3img19120305.dcea9d1a.jpg";